import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'
import MenuTrigger from 'component/menu/MenuTrigger'
import MenuItem from 'component/menu/MenuItem'
import UserProfile from 'component/menu/UserProfile'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as accessMenusActions from 'action/menu'

class Menu extends Component {
  static propTypes = {
    menu: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    accessMenus: PropTypes.func.isRequired,
  }

  componentDidMount() {
    document.addEventListener('click', this.handleOutsideClick)
    document.addEventListener('keydown', this.handleOutsideClick)
  }

  handleCloseMenu = () => {
    document.body.classList.remove('navigation-visible')
  }

  handleOutsideClick = (ev) => {
    if (this.menu) {
      if (
        (ev.type === 'keydown' && ev.keyCode === 27) ||
        (ev.type === 'click' && !this.menu.contains(ev.target))
      ) {
        this.handleCloseMenu()
      }
    }
  }

  clickMenu = (cdMenu) => {
    const { accessMenus, user } = this.props

    accessMenus(user, cdMenu)
    document.body.classList.remove('navigation-visible')

    return false
  }

  renderMenuItem = (cdMenu) => {
    const { user, menu, translate } = this.props

    const menuItem = menu[cdMenu]

    return (
      <div key={menuItem.cdMenu}>
        <MenuItem translate={translate} menu={menuItem} user={user} />
        {Object.keys(menuItem.subItems).map((menuSubItemKey) => {
          const menuSubItem = menuItem.subItems[menuSubItemKey]

          return (
            <ul
              key={menuSubItem.cdMenu}
              className='navigation-menu-sub-item-content'
            >
              <Link
                to={`/${menuSubItem.dsView}`}
                onClick={() => {
                  this.clickMenu(menuSubItem.cdMenu)
                }}
              >
                <li className='navigation-menu-sub-item'>
                  <span className='navigation-name'>
                    {translate(menuSubItem.dsChaveMenu)}
                  </span>
                </li>
              </Link>
            </ul>
          )
        })}
      </div>
    )
  }

  render() {
    const { user, menu, translate } = this.props

    return (
      <section ref={(c) => {this.menu = c}}>
        <nav className='navigation-menu'>
          <div className='navigation-menu-title'>
            <button
              className='toggle-navigation float-right clickable'
              onClick={this.handleCloseMenu}
            >
              <i className='glyph glyph-x' />
            </button>
          </div>

          <UserProfile user={user} />

          {menu && Object.keys(menu).map(this.renderMenuItem)}
        </nav>

        <MenuTrigger translate={translate} />
      </section>
    )
  }
}

Menu.propTypes = {
  menu: PropTypes.object,
  user: PropTypes.object.isRequired,
  translate: PropTypes.func.isRequired,
}

/*
 * Maps redux state to component props
 */
/* istanbul ignore next */
const mapStateToProps = () => ({})

/*
 * Maps actions and dispatch them to component props
 */
/* istanbul ignore next */
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(accessMenusActions, dispatch)

/*
 * Exports component connected to redux as default
 */
export default connect(mapStateToProps, mapDispatchToProps)(Menu)

export { Menu }
